import { useEffect } from 'react';

import { getPartnerAllianceInfo } from '~components/AllianceCallService/AllianceCallService';
import { getCookie, setCookie } from '~globals/common';
import constants from '~globals/constants';
import { isSEO } from '~globals/isSeo';
import { useAppSelector } from '~hooks/useRedux';

const useSelectedAllianceId = (search: string) => {
    const defaultAllid = constants.DEFAULT_ALLIANCE_ID;
    const allid = useAppSelector((state) => state.global.allianceId);
    const cameFromSEO = typeof window !== 'undefined' ? isSEO(document.referrer) : false;
    const defaultAllidSEO = constants.DEFAULT_SEO_ALLIANCE_ID;
    const urlParams = Object.fromEntries(new URLSearchParams(search).entries());

    // default alliance
    let selectedAllid: string = defaultAllid;
    // allid local storage (old) / ehState (new)
    if (allid) {
        selectedAllid = allid;
    }
    // ehi.alliance_id cookie
    const allidFromCookie = getCookie('ehi.alliance_id') as string;
    if (allidFromCookie && allidFromCookie !== 'ehe12862000') {
        selectedAllid = allidFromCookie;
    }
    // SEO values - if the "cameFromSEO" is true, set the alliance id to that
    if (cameFromSEO) {
        selectedAllid = defaultAllidSEO;
    }
    // URL param - this will always overwrite what's in storage
    selectedAllid = urlParams.allid || selectedAllid;

    if (Object.keys(urlParams).length !== 0) {
        Object.keys(urlParams).forEach((p) => {
            if (!urlParams[p]) {
                return;
            }
            if (p.toLowerCase() === 'pid') {
                if (p !== 'pid') {
                    urlParams.pid = urlParams[p];
                    delete urlParams[p];
                }
                setCookie('ehi.alliance_pid', urlParams.pid);
                return;
            }
            if (p.toLowerCase() === 'sid') {
                if (p !== 'sid') {
                    urlParams.sid = urlParams[p];
                    delete urlParams[p];
                }
                setCookie('ehi.alliance_sid', urlParams.sid);
                return;
            }
            if (p.toLowerCase() === 'campaign') {
                setCookie('ehi.alliance_campaign', urlParams.campaign);
            }
        });
    }

    useEffect(() => {
        getPartnerAllianceInfo(selectedAllid).catch((e) => {
            console.warn('[useSelectedAllianceId]', e);
        });
    }, [selectedAllid]);

    return { selectedAllid, urlParams };
};

export default useSelectedAllianceId;
